import ReactDOM from 'react-dom/client';
import App from '@/App';
import { initApp } from '@/init';
import { initI18n } from '@/locales/i18n';

// Initialize app before React renders
initApp();

// Load the active language's translations before the first paint, so the UI
// never flashes raw i18n keys. Render regardless if i18n init fails.
initI18n().finally(() => {
  ReactDOM.createRoot(document.getElementById('root')).render(<App />);
});
